'use strict';

exports = module.exports = {
  // List of user roles

  // User: Authenticated users like patients and staff at hospitals / clinics etc.
  // GroupAdmin: Group level admins; can manage single group.
  // SafeStart Admin: admins at the SafeStart company who can manage "everything"
  // SuperAdmin: Developer level admins who gain full access to certain high risk features.

  userRoles: ['guest', 'user', 'groupadmin', 'safestartadmin', 'superadmin'],
  staffRoles: ['physician']
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 18
// module chunks = 0